export default "__VITE_PUBLIC_ASSET__106e69b4__"